// extracted by mini-css-extract-plugin
export var quillEditor = "_ia-1";
export var variable = "_ia-0";